import CONSTANT from 'modules/constant'
import type {
    CarInjectionJob,
    CarInjectionPagedRowResponse,
    CarInjectionUploadResponse,
    PaginationProps
} from 'modules/types'
import { API, download, headers } from './api'

const CarInjectionAPI = API.injectEndpoints({
    endpoints: (builder) => ({
        getInjectionJobs: builder.mutation<PaginationProps<CarInjectionJob>, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_CAR_INJECTION_LIST,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true
            })
        }),
        uploadInjectionJob: builder.mutation<CarInjectionUploadResponse, FormData>({
            query: (body) => ({
                url: CONSTANT.URL_CAR_INJECTION_UPLOAD,
                method: 'POST',
                headers: headers({ useContentType: false }),
                body: body,
                formData: true
            })
        }),
        getInjectionJobDetail: builder.query<CarInjectionJob, string>({
            query: (jobId) => ({
                url: CONSTANT.URL_CAR_INJECTION_JOB_DETAIL + jobId,
                method: 'GET',
                headers: headers()
            })
        }),
        getInjectionJobRows: builder.query<CarInjectionPagedRowResponse, { jobId: string; status?: string; page?: number; pageSize?: number }>({
            query: ({ jobId, status, page = 1, pageSize = 20 }) => ({
                url: CONSTANT.URL_CAR_INJECTION_JOB_ROWS + jobId,
                params: { status, page, pageSize },
                method: 'GET',
                headers: headers()
            })
        }),
        retryFailedInjection: builder.mutation<CarInjectionUploadResponse, string>({
            query: (jobId) => ({
                url: CONSTANT.URL_CAR_INJECTION_RETRY + jobId,
                method: 'POST',
                headers: headers()
            }),
            invalidatesTags: ['CarInjectionList']
        }),
        downloadInjectionTemplate: builder.mutation<void, void>({
            query: () => ({
                url: CONSTANT.URL_CAR_INJECTION_TEMPLATE,
                method: 'GET',
                headers: headers(),
                responseHandler: download
            })
        }),
        downloadRows: builder.mutation<void, string>({
            query: (jobId) => ({
                url: CONSTANT.URL_CAR_INJECTION_DOWNLOAD_ROWS.replace('{jobId}', jobId),
                method: 'GET',
                headers: headers(),
                responseHandler: download
            })
        })
    })
})

export const {
    useGetInjectionJobsMutation,
    useUploadInjectionJobMutation,
    useGetInjectionJobDetailQuery,
    useGetInjectionJobRowsQuery,
    useRetryFailedInjectionMutation,
    useDownloadInjectionTemplateMutation,
    useDownloadRowsMutation
} = CarInjectionAPI
